<script setup lang="ts">
/* UTILS */
/* COMPONENTS */
import { ALIconButton } from '@af-lib/vue-ui';
import { useQueryClient } from '@tanstack/vue-query';
import { computed, watch } from 'vue';
import { useCssBreakpoints } from '@af-lib/vue-ui';

import { BATCH_EVENTS } from '@/api/clients/pusher/events.enums';
import ReverbClient from '@/api/clients/pusher/ReverbClient';
import Reporter from '@/api/clients/reporter/reporter';
import { displayGenericErrorToaster } from '@/api/helpers/helpers';
/* API */
import { useGetBatchesSummaryQuery } from '@/api/vue-query/batches/batches.queries';
/* STORES */
import { useOverlayStore } from '@/components/drawers/overlayStore';
import { useAuthStore } from '@/stores/auth';

/* UTILS */
const overlayStore = useOverlayStore();
const { tabletAndUp } = useCssBreakpoints();
const BATCHES_DRAWER = 'batches';
const uuid = useAuthStore().getCompanyUuid;
const queryClient = useQueryClient();
const CHANNEL_NAME = `app.batches.company.${uuid}`;
const reverbClient = ReverbClient();
const reverbChanel = reverbClient.getInstance().private(CHANNEL_NAME);

/* API */
const { data: batchesRecap, isError } = useGetBatchesSummaryQuery();

/* REF */
const isIconDisplayed = computed(() => !!batchesRecap.value?.nb_batches_total);
const hasErrorProcesses = computed(() => !!batchesRecap.value?.nb_batches_failed); // true if errors in any of the batches
// display cloud icon when new action queued
function openBatchesDrawer() {
  overlayStore.toggle(BATCHES_DRAWER);
  Reporter().reportData('open_batch_panel');
}

/* EVENTS LISTENING */
reverbChanel.listen(BATCH_EVENTS.FINISH, () => {
  queryClient.invalidateQueries({ queryKey: ['getBatchesSummary'] });
});

watch(isError, () => {
  if (isError.value) displayGenericErrorToaster();
});
</script>

<template>
  <div v-if="isIconDisplayed && tabletAndUp">
    <v-badge v-model="hasErrorProcesses" :offsetX="10" :offsetY="12" bordered style="cursor: pointer">
      <ALIconButton
        icon="fas fa-cloud-upload"
        variant="tertiary"
        :label="$t('accessibility.queue.view')"
        :shouldTeleportTooltip="true"
        @click="openBatchesDrawer"
      />
    </v-badge>
  </div>
</template>
